import INTERNAL_QUERY_PARAMS from "@/constants/internalQueryParams";
import VisibilityTracker from "@/utils/visibility-tracker.js";

const embedMixins = {
  props: {
    id: {
      type: String,
      required: true,
    },
    preview: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sandboxPermissions:
        "allow-forms allow-scripts allow-same-origin allow-popups allow-top-navigation allow-storage-access-by-user-activation allow-downloads",
      allowedPermissions: "geolocation; microphone; camera; fullscreen",
      visibilityTracker: null,
      iframeVisible: false,
    };
  },
  computed: {
    surveyUrl() {
      return this.preview
        ? `${this.url}?${INTERNAL_QUERY_PARAMS.preview}=true`
        : this.url + this.queryParams;
    },
    queryParams() {
      const query = new URLSearchParams(window.location.search);
      return `?${query.toString()}`;
    },
  },
  beforeUnmount() {
    if (this.visibilityTracker) {
      this.visibilityTracker.destroy();
    }
  },
  methods: {
    initializeIframeVisibilityTracking() {
      this.visibilityTracker = new VisibilityTracker();
      
      this.$nextTick(() => {
        const iframe = this.$refs.formesterIframe;
        if (iframe) {
          this.visibilityTracker.track(iframe, () => {
            this.iframeVisible = true;
            
            // Send visibility message to iframe content
            try {
              iframe.contentWindow?.postMessage({
                type: 'formester-iframe-visible',
                visible: true
              }, '*');
            } catch (error) {
              console.warn('Could not send visibility message to iframe:', error);
            }
          });
        }
      });
    },
  },
};

export default embedMixins;
